<template>
  <vxe-table
    ref="elTable"
    v-bind="$attrs"
    :loading="loading"
    border
    width="100%"
    class="vxe-table-box"
    show-overflow="tooltip"
    show-header-overflow="tooltip"
    :size="size"
    :data="newRows"
    :height="height"
    :row-class-name="rowClassHandler"
    :column-config="{ resizable: true }"
    :scroll-y="{enabled: true}"
    :scroll-x="{enabled: true}"
    :sort-config="{
      trigger: 'cell',
      defaultSort,
      orders: ['desc', 'asc', null],
    }"
    :checkbox-config="selection?checkboxConfigChecked:{}"
    :cell-config="{
        height:'35px'
    }"
    :empty-text="tableConfig.emptyText"
    @sort-change="sortChange"
    @cell-click="rowClick"
    @cell-dblclick="handleCellDblClick"
    @checkbox-all="handleSelectionAll"
    @checkbox-change="handleSelectionChange"
    @checkbox-range-change="handleSelectionChange"
    @resizable-change="headerDragendHandler"
  >
    <vxe-column
      v-if="selection"
      type="checkbox"
      width="40"
      align="center"
      fixed="left"
    ></vxe-column>
    <vxe-column
      :key="col.prop + '' + cIndex"
      v-for="(col, cIndex) in columns"
      :fixed="col.fixed"
      :title="col.label"
      :width="col.width"
      :min-width="col.minWidth"
      :sortable="col.sort"
      :field="col.prop"
      :show-header-overflow="showOverflowTooltip(col)"
      :align="col.align || ''"
    >
      <template #header="scope">
        <span>
          <span class="table-header-mustFill" v-if="col.mustFill">* </span>
          {{ col.label }}
        </span>
        <el-tooltip
          v-if="col.info"
          class="item"
          effect="dark"
          placement="bottom"
        >
          <div slot="content" v-html="col.info"></div>
          <i class="el-icon-question" style="color: #f96c5f"></i>
        </el-tooltip>
      </template>
      <template #default="scope">
        <template v-if="col.type === 'custom'">
          <slot name="customTableCell" v-bind="{ ...scope, col }" />
        </template>
        <div v-else-if="col.type === 'photos'">
          <div v-if="scope.row.showPhotos" style="line-height: 0px;">
            <img
              src="@/assets/photos.png"
              @click.stop="fatherEmit('btnEvent', 'photos', scope.row)"
              @dblclick.stop=""
              style="width: 20px; cursor: pointer;"
            />
          </div>
          <div v-else-if="scope.row.noShowPhotos"></div>
          <div v-else>
            <el-button
              size="mini"
              type="text"
              @click.stop="fatherEmit('btnEvent', 'upload', scope.row)"
              @dblclick.stop=""
              v-if="col.ifHas"
              v-has="col.ifHas"
            >
              {{
                $translate("component.E202007310005", { defaultText: "上传" })
              }}
            </el-button>
            <el-button
              size="mini"
              type="text"
              @click.stop="fatherEmit('btnEvent', 'upload', scope.row)"
              @dblclick.stop=""
              v-else
            >
              {{
                $translate("component.E202007310005", { defaultText: "上传" })
              }}
            </el-button>
          </div>
        </div>
        <div v-else-if="col.type === 'customPhotos'">
          <div v-if="scope.row[col.prop + 'ShowPhotos']" style="line-height: 0px;">
            <img
              src="@/assets/photos.png"
              @click.stop="fatherEmit('btnEvent', 'photos', { row: scope.row, prop: col.prop })"
              @dblclick.stop=""
              style="width: 20px; cursor: pointer;"
            />
          </div>
          <div v-else-if="scope.row[col.prop + 'NoShowPhotos']"></div>
        </div>
        <div v-else-if="col.type === 'link'">
          <a :href="scope.row[col.prop]" target="_blank">{{
            scope.row.linkName || scope.row[col.prop]
          }}</a>
        </div>
        <div v-else-if="col.type === 'trajectory'">
          <div style="line-height: 0px;">
            <img
              src="@/assets/gps.png"
              @click.stop="fatherEmit('btnEvent', 'trajectory', scope.row)"
              @dblclick.stop=""
              style="width: 20px; cursor: pointer;"
            />
          </div>
        </div>
        <div v-else-if="col.type === 'clickable'">
          <span
            class="col-clickable"
            type="text"
            size="mini"
            @click.stop="
              fatherEmit(
                'btnClick',
                scope.row[col.prop],
                scope.$index,
                scope.row,
                col.prop
              )
            "
          >
            {{ scope.row[col.prop] }}
          </span>
        </div>
        <div v-else-if="col.type === 'button'">
          <el-button
            type="text"
            size="mini"
            @contextmenu.prevent.native="
              fatherEmit(
                'btnRightClick',
                scope.row[col.prop],
                scope.$index,
                scope.row,
                col.prop
              )
            "
            @click.stop="
              fatherEmit(
                'btnClick',
                scope.row[col.prop],
                scope.$index,
                scope.row,
                col.prop
              )
            "
          >
            {{ scope.row[col.prop] }}
          </el-button>
        </div>
        <div v-else-if="col.type === 'detail'">
          <el-button
            size="mini"
            v-if="!scope.row[col.emitEvent + 'Hidden']"
            type="text"
            @click.stop="
              fatherEmit('btnEvent', col.emitEvent || 'detail', scope.row)
            "
            @dblclick.stop=""
          >
            {{
              col.buttonName ||
                $translate("component.E1202104121763", { defaultText: "明细" })
            }}
          </el-button>
        </div>
        <div v-else-if="col.type === 'select' && col.differentStatus">
          <span :style="getColorByDifferentStatus(col, scope.row)">
            {{
              col.type !== "select" && col.type !== "cascader"
                ? scope.row[col.prop]
                : selectToNormal(col, scope.row)
            }}
          </span>
        </div>
        <template v-else>
          {{
            col.type !== "select" && col.type !== "cascader"
              ? scope.row[col.prop]
              : selectToNormal(col, scope.row)
          }}
        </template>
      </template>
    </vxe-column>

    <vxe-column
      :width="actionColWidth"
      v-if="actionColShow"
      fixed="right"
      :title="$translate('component.E202006152352', { defaultText: '操作' })"
      align="center"
    >
      <template slot-scope="scope">
        <div class="action">
          <template v-if="tableConfig.hasMaxBtnNum">
            <template
              v-if="
                tableConfig.action.filter(
                  (el) => !scope.row.hiddenEvent.includes(el.event)
                ).length <= +maxOperationBtnNum
              "
            >
              <span
                v-for="(item, index) in tableConfig.action.filter(
                  (el) => !scope.row.hiddenEvent.includes(el.event)
                )"
                :key="index"
                :class="{
                  pad: ![].concat(scope.row.hiddenEvent).includes(item.event),
                }"
              >
                <el-button
                  size="mini"
                  @click.stop="btnEvent(scope.row, item.event)"
                  :type="item.type"
                >
                  {{ item.label }}
                </el-button>
              </span>
            </template>
            <template v-else>
              <span
                v-for="(item, index) in tableConfig.action
                  .filter((el) => !scope.row.hiddenEvent.includes(el.event))
                  .slice(0, maxOperationBtnNum)"
                :key="index"
                :class="{
                  pad: ![].concat(scope.row.hiddenEvent).includes(item.event),
                }"
              >
                <el-button
                  size="mini"
                  @click.stop="btnEvent(scope.row, item.event)"
                  :type="item.type"
                >
                  {{ item.label }}
                </el-button>
              </span>
              <el-dropdown class="more-btn">
                <span class="el-dropdown-link mainColor">{{
                  $translate("component.E202011270001", { defaultText: "更多" })
                }}</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in tableConfig.action
                      .filter((el) => !scope.row.hiddenEvent.includes(el.event))
                      .slice(maxOperationBtnNum)"
                    :key="item.event + index"
                    @click.native="btnEvent(scope.row, item.event)"
                  >
                    <el-button size="mini" :type="item.type">{{
                      item.label
                    }}</el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
          <template v-else>
            <span v-if="!tableConfig.customBtn">
              <span v-for="(item, index) in tableConfig.action" :key="index">
                <span
                  v-if="item.ifHas"
                  v-has="item.ifHas"
                  :class="{
                    pad: ![].concat(scope.row.hiddenEvent).includes(item.event),
                  }"
                >
                  <el-button
                    size="mini"
                    @click.stop="btnEvent(scope.row, item.event)"
                    :type="item.type"
                    v-if="
                      ![].concat(scope.row.hiddenEvent).includes(item.event)
                    "
                  >
                    {{ item.label }}
                  </el-button>
                </span>
                <span
                  v-else
                  :class="{
                    pad: ![].concat(scope.row.hiddenEvent).includes(item.event),
                  }"
                >
                  <el-button
                    size="mini"
                    @click.stop="btnEvent(scope.row, item.event)"
                    :type="item.type"
                    v-if="
                      ![].concat(scope.row.hiddenEvent).includes(item.event)
                    "
                  >
                    {{ item.label }}
                  </el-button>
                </span>
              </span>
            </span>
            <template v-else>
              <span v-for="(item, index) in tableConfig.action" :key="index">
                <span v-for="(child, i) in item" :key="i">
                  <span v-if="item.ifHas" v-has="item.ifHas">
                    <el-button
                      size="mini"
                      @click.stop="btnEvent(scope.row, child.event)"
                      :type="child.type"
                      v-if="
                        child.displayCode ===
                          scope.row[tableConfig.btnDisplayCredentials[index]]
                      "
                    >
                      {{ child.label }}
                    </el-button>
                  </span>
                  <template v-else>
                    <el-button
                      size="mini"
                      @click.stop="btnEvent(scope.row, child.event)"
                      :type="child.type"
                      v-if="
                        child.displayCode ===
                          scope.row[tableConfig.btnDisplayCredentials[index]]
                      "
                    >
                      {{ child.label }}
                    </el-button>
                  </template>
                </span>
              </span>
            </template>
            <el-dropdown v-if="tableConfig.hasMoreAction">
              <span class="el-dropdown-link mainColor">
                {{
                  $translate("component.E202011270001", { defaultText: "更多" })
                }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in tableConfig.MoreAction"
                  :key="index"
                  v-show="!!isShow(index, scope.row.showIndex)"
                >
                  <span v-if="item.ifHas" v-has="item.ifHas">
                    <el-button
                      size="mini"
                      @click="moreEvent(scope.row, index)"
                      :type="item.type"
                      >{{ item.label }}</el-button
                    >
                  </span>
                  <template v-else>
                    <el-button
                      size="mini"
                      @click="moreEvent(scope.row, index)"
                      :type="item.type"
                      >{{ item.label }}</el-button
                    >
                  </template>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </div>
      </template>
    </vxe-column>
  </vxe-table>
</template>

<script>
import _ from 'lodash';
import { I18nMixins } from '@/components/utils/i18n';
export default {
    name: 'PerformanceVxeTable',
    mixins: [I18nMixins],
    props: {
        actions: {
            type: Object,
            default() {
                return {
                    list: []
                };
            },
            validator: function(obj) {
                return !!obj.list;
            }
        },
        loading: {
            type: Boolean,
            default() {
                return false;
            }
        },
        highlight: {
            type: Boolean,
            default() {
                return true;
            }
        },
        columns: {
            type: Array,
            required: true,
            default() {
                return [];
            }
        },
        rows: {
            type: Array,
            required: true,
            default() {
                return [];
            }
        },
        /** 高亮行样式代码 */
        highlightRowClass: Function,
        selection: {
            type: Boolean,
            default() {
                return true;
            }
        },
        index: {
            type: Boolean,
            default() {
                return false;
            }
        },
        size: {
            default() {
                return 'medium';
            }
        },
        height: {
            default() {
                return '100%';
            }
        },
        tableConfig: Object,
        maxOperationBtnNum: Number,
        selectToNormal: Function,
        fatherEmit: Function,
        btnEvent: Function,
    },
    data() {
        return {
            defaultSort: { field: 'age', order: 'desc' },
            newRows: [],
            checkboxConfigChecked: {
                checkField: 'checkboxConfigChecked',
                trigger: 'row',
                highlight: this.highlight,
                range: true
            },
            multipleSelection: [],
            cacheVirtual: {
                path: null
            },
            dictFormat: (val) => val
        };
    },
    computed: {
        actionColShow() {
            return this.tableConfig && this.tableConfig.leftOperation !== false && this.actions.list && this.actions.list.length > 0;
        },
        actionColWidth() {
            const btnWidth = 50;
            return this.tableConfig.leftWidth
                ? this.tableConfig.leftWidth
                : this.actions.fixedWidth || btnWidth * this.actions.list.length;
        }
    },
    methods: {
        /**
         * 虚拟表格在标签页面切换回来的时候，会出现显示位置空白，进行一次数据重新渲染
         * 它官方提供的刷新方法都不起效果，所以需要自己进行处理
        */
        async reloadView() {
            const table = this.$refs.elTable;
            const checked = table.getCheckboxRecords();
            await table.reloadData(table.data);
            await table.setCheckboxRow(checked, true);
            table.sort(this.defaultSort);
        },
        /** 获取 vxe 表格中的 data 响应式数据 */
        getTableData() {
            return this.$refs.elTable.data;
        },
        /** 因为 vxe-table 内部进行了一次封装，导致 row 的数据结构发生了变化，这里进行一层转换 */
        changeToOriginRow(row) {
            return this.rows[row.$rowIndex];
        },
        inputBlur(value, row, prop) {
            row[prop] = value;
        },
        actionClick(event, row, rIndex) {
            this.$emit('action-click', event, this.changeToOriginRow(row), rIndex);
        },
        rowClassHandler ({ row }) {
            if (typeof this.highlightRowClass === 'function') {
                const res = this.highlightRowClass(row)
                if (res) return res
            }
            if (row.highlighted) return 'rowRedColor';
            if (row.isSelectedRow) return 'selected-bgc';
            return this.multipleSelection.includes(row) ? 'selected-row' : '';
        },
        // 点击勾选当前行的复选框
        rowClick({ row }) {
            this.$emit('row-click', this.changeToOriginRow(row));
        },
        // 排序,排序后，获取 row 仍然是正确的
        sortChange({ column }) {
            this.defaultSort = {
                field: column.property,
                order: column.order
            };
            this.$emit('sortChange', column);
        },
        handleCellDblClick ({ row, rowIndex, $rowIndex, column }) {
            this.$emit('cell-dblclick', this.changeToOriginRow(row), rowIndex, $rowIndex, column);
            this.$emit('row-dblclick', this.changeToOriginRow(row), rowIndex, $rowIndex, column);
        },
        /** 全选 */
        handleSelectionAll(val) {
            if (this.selection) {
                this.multipleSelection = val.checked ? this.newRows : [];
                this.$emit('selection-change', this.multipleSelection);
            }
        },
        /** 获取表格现在选中的行 */
        getSelection() {
            return this.$refs.elTable.getCheckboxRecords().map(i => this.changeToOriginRow(i));
        },
        /** 单选事件 */
        handleSelectionChange(val) {
            // 配置多选的情况下
            if (this.selection) {
                const row = this.changeToOriginRow(val.row || (val.records && val.records[val.records.length - 1]));
                this.multipleSelection = this.getSelection();
                this.$emit('selection-change', this.multipleSelection, row, val.checked);
                this.$emit('select', this.multipleSelection, row, val.checked);
            }
        },
        /** 列宽拖动事件 */
        headerDragendHandler({ event, column, resizeWidth }) {
            this.$emit('header-dragend', resizeWidth, undefined, column, event);
        },
        // 添加showOverflowTooltip，就不需要return _
        showOverflowTooltip(col) {
            return _.get(col, 'showTooltip', true);
        },
        handleLinkClick(url, requestParam) {
            const requestUrl = this.appendParamsToUrl(url, requestParam);
            window.open(requestUrl);
        },
        handleDownload(url) {
            window.open(url);
        },
        appendParamsToUrl(url, params) {
            // 检查参数是否为空对象
            if (Object.keys(params).length === 0) {
                return url;
            }
            // 构造参数字符串
            var paramStr = Object.entries(params)
                .map(
                    ([key, value]) =>
                        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
                )
                .join('&');
            // 检查 URL 中是否已经有查询字符串
            var separator = url.includes('?') ? '&' : '?';
            // 拼接 URL 和参数字符串
            return url + separator + paramStr;
        }
    },
    mounted() {
        this.cacheVirtual.path = this.$route.path;
    },
    watch: {
        rows: {
            handler(newVal, oldVal) {
                this.newRows = newVal.map((item, index) => {
                    item.$rowIndex = index;
                    return item;
                });
                this.newRows.forEach((item) => {
                    if (!item.hasOwnProperty('checkboxConfigChecked')) {
                        item.checkboxConfigChecked = false;
                    }
                });
                this.$emit('on-reload-data');
            },
            immediate: true,
            deep: true
        },
        $route(val, oldVal) {
            if (val.path === this.cacheVirtual.path) { this.reloadView(); }
        }
    }
};
</script>
<style lang="less">
@import "./VirtualTable.less";
.vxe-table-box .vxe-header--column {
  height: 34px !important;
}
.vxe-table--render-default .vxe-body--row.row--checked {
  background-color: #e1e9ef;
}
.vxe-header--column.col--ellipsis > .vxe-cell .vxe-cell--title {
  cursor: pointer;
  user-select: none;
}
.vxe-table-box  .mainColor {
    color: #00bcbf!important;
}
.rowRedColor {
    background-color: #ed8491;
}
.selected-bgc {
    background-color: #e7f7f7;
}
</style>
